module.exports = __webpack_public_path__ + "img/dq.e7d449e6.png";